import React from 'react';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import { injectIntl, IntlShape } from 'react-intl';

import CustomMap from 'containers/ServicesPage/Map';
import { GridContainer } from 'containers/ServicesPage/styles';
import HeaderAgentInfo from 'components/AgentInfo/HeaderAgentInfo';
import BodyAgentInfo from 'components/AgentInfo/BodyAgentInfo';
import { StyledDivider } from 'containers/AgentPage/body/style';
import { useMediaQuery, useTheme } from '@material-ui/core';

const Body = (props: {
  intl: IntlShape;
  nameAgent: string;
  AdresseAgent: string;
  villeAgent: string;
  horaireLundiJeudi: string;
  horaireVendredi: string;
  horaireSamedi: string;
  phone: string;
  email: string;
  marker: {
    icon: any;
    position: {
      lat: number;
      lng: number;
    };
  }[];
}) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <GridContainer container direction={matches ? 'column' : 'row'}>
      {matches && (
        <Grid item xs={12}>
          <CustomMap markers={props.marker} />
        </Grid>
      )}
      <Grid item xs={matches ? 12 : 6}>
        <Box px={matches ? 2 : 4.5} py={4}>
          <HeaderAgentInfo
            nameAgent={props.nameAgent}
            AdresseAgent={props.AdresseAgent}
            villeAgent={props.villeAgent}
            lat={props.marker[0].position.lat}
            lng={props.marker[0].position.lng}
          />
          <StyledDivider />
          <BodyAgentInfo
            horaireLundiJeudi={props.horaireLundiJeudi}
            horaireVendredi={props.horaireVendredi}
            horaireSamedi={props.horaireSamedi}
            phone={props.phone}
            email={props.email}
          />
        </Box>
      </Grid>
      {!matches && (
        <Grid item xs={6}>
          <CustomMap markers={props.marker} />
        </Grid>
      )}
    </GridContainer>
  );
};

export default injectIntl(Body);
